import { Fragment } from 'react'

import { createDataAttribute } from 'next-sanity'

import { NavigationItem } from '@/app/components/NavigationItem'
import { TrackingLocation } from '@/app/utils/analytics'
import { cn } from '@/app/utils/style'
import { NavQueryResult } from '@/sanity.types'

interface NavigationProps {
  classNames?: {
    root?: string
    label?: string
    list?: string
    item?: string
    button?: string
    link?: string
    separator?: string
  }
  includeSeparator?: boolean
  label?: string
  nav: NavQueryResult[number] | null
  tracking: TrackingLocation
}

export const Navigation = function ({
  classNames,
  includeSeparator,
  label,
  nav,
  tracking,
}: NavigationProps) {
  if (!nav) {
    return null
  }

  const attr = createDataAttribute({
    id: nav._id,
    type: 'navigation',
    path: 'navigation',
  })

  return (
    <nav className={cn(classNames?.root)} data-sanity={attr.toString()}>
      {label && (
        <p
          className={cn(
            'size-overline-sm leading-overline-sm tracking-overline-sm font-black uppercase text-primary-600',
            classNames?.label,
          )}
        >
          {label}
        </p>
      )}
      <ul role="list" className={cn('', classNames?.list)}>
        {nav.menu.items?.map((item, index) => (
          <Fragment key={item._key}>
            <NavigationItem
              classNames={{
                root: classNames?.item,
                button: classNames?.button,
                link: classNames?.link,
              }}
              item={item}
              tracking={tracking}
            />
            {includeSeparator && index < (nav.menu.items?.length ?? 0) - 1 && (
              <li className={classNames?.separator} />
            )}
          </Fragment>
        ))}
      </ul>
    </nav>
  )
}
